import React from 'react';
export function ProblemSection() {
  return <section className="py-12 md:py-20 bg-zinc-900/50 border-y border-zinc-800/50" data-id="element-199">
      <div className="container mx-auto px-4" data-id="element-200">
        <div className="max-w-3xl mx-auto" data-id="element-201">
          <h2 className="text-2xl md:text-4xl font-serif font-bold text-center mb-6 md:mb-12 text-white" data-id="element-202">
            Seamos honestos.
          </h2>

          <p className="text-base md:text-xl text-zinc-300 mb-6 md:mb-10 text-center" data-id="element-203">
            En Argentina hay dos tipos de personas.
          </p>

          <div className="space-y-6 md:space-y-12" data-id="element-204">
            {/* Persona 1 */}
            <div className="bg-zinc-900 border border-zinc-800 p-5 md:p-10 rounded-2xl relative overflow-hidden" data-id="element-205">
              <div className="absolute top-0 left-0 w-1 h-full bg-amber-500" data-id="element-206"></div>
              <p className="text-sm md:text-lg text-zinc-300 mb-4 md:mb-6 leading-relaxed" data-id="element-207">
                <strong className="text-white text-base md:text-xl" data-id="element-208">
                  Las que hacen el asado.
                </strong>
              </p>
              <p className="text-sm md:text-lg text-zinc-300 leading-relaxed" data-id="element-209">
                Si estás en este grupo: sabés que hay una diferencia enorme
                entre el asado que sale bien y el que la gente recuerda semanas
                después. Entre el que arranca con confianza y el que improvisa
                rezando para que no salga mal.
              </p>
            </div>

            {/* Persona 2 */}
            <div className="bg-zinc-900 border border-zinc-800 p-5 md:p-10 rounded-2xl relative overflow-hidden" data-id="element-210">
              <div className="absolute top-0 left-0 w-1 h-full bg-zinc-500" data-id="element-211"></div>
              <p className="text-sm md:text-lg text-zinc-300 mb-4 md:mb-6 leading-relaxed" data-id="element-212">
                <strong className="text-white text-base md:text-xl" data-id="element-213">
                  Y las que esperan que lo haga otro.
                </strong>
              </p>
              <p className="text-sm md:text-lg text-zinc-300 leading-relaxed" data-id="element-214">
                Si estás en este grupo: sabés que en algún momento te va a
                tocar. Y cuando llegue ese momento, querés que salga bien de
                verdad. No "pasable". Bien.
              </p>
            </div>
          </div>

          <div className="mt-8 md:mt-16 text-center" data-id="element-215">
            <h3 className="text-xl md:text-3xl font-bold text-white mb-4 md:mb-6" data-id="element-216">
              Los dos necesitan lo mismo.
            </h3>
            <p className="text-sm md:text-xl text-zinc-300 leading-relaxed" data-id="element-217">
              Un sistema. No consejos sueltos. No videos de YouTube gringo. Un
              sistema hecho para Argentina.
            </p>
          </div>
        </div>
      </div>
    </section>;
}